"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.user.speaking': 'Użytkownik mówi',
    'conversation.user.silent': 'Użytkownik milczy',
};
